module.exports = __webpack_public_path__ + "static/media/hand.svg.b7406ce9.png";